import { AxiosInstance } from 'axios';

import { IFormData } from 'src/views/LinkCreate/types';
import { toResponse } from '../genericToResponse';

export default (api: AxiosInstance, url: string) => async (
  data: IFormData,
  confirm = false
) => {
  const response = await api.post(url, {
    ...data,
    ConfirmDuplicateLink: confirm,
  });
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/link/create.ts